export const APPROVAL_COLUMN_TYPE = 'approval';
export const APPROVAL_STATUS_PENDING = 'pending';
export const APPROVAL_STATUS_NOT_STARTED = 'not_started';
export const APPROVAL_STATUS_CANCELLED = 'cancelled';
export const APPROVAL_STATUS_APPROVED = 'approved';
export const APPROVAL_STATUS_REJECTED = 'rejected';
export const APPROVAL_STATUS_NOT_NEEDED = 'no_approval_needed';